<template>
  <div class="chat-button-widget">
    <a href="#" @click="showChatChannels">
      <i class="far fa-comments chat-button-icon"></i>
      <span v-if="unreadCount > 0" class="chat-badge-unread chat-button-unread">{{ unreadCount }}</span>
      <span v-else class="chat-badge-unread chat-badge-unread-hide"></span>
    </a>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'chat-button',
  computed: {
    ...mapGetters('chat', ['unreadCount'])
  },
  methods: {
    showChatChannels() {
      this.$emit('showChatChannels')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-button.vue